import React, { useEffect, useState} from 'react'
import {
  Box,
  Text,
  IcoMoon,
  KeyboardArrowDownIcon,
  KeyboardArrowUpIcon, MediaBox,
} from '@usap/uicomponents'
import { ShowMoreButton, StyledLinkBox } from './style/LinkWithtext.css'

export default function LinkWithText({
  gridId,
  elementId,
  data,
  colWidth,
  Link,
  skip,
  showMoreLimit,
  handleClick = () => {},
}) {
  const [showmoreFlag, setShowmoreFlag] = useState(true)

  const showLimit = showMoreLimit === undefined ? 0 : showMoreLimit
  const displayMoreBtn = showLimit > 0 && data.length > showLimit

  let records = data
  if (displayMoreBtn && showmoreFlag) {
    records = data.slice(0, showLimit)
  }

  useEffect(() => {
    setShowmoreFlag(true)
  }, [])

  return (
    <Box id={gridId} direction="row" wrap>
      {records && records.map(({ text, link }, index) => {
        const mapKey = `${text}-${index}`
        return (
          <MediaBox
            key={mapKey}
            id={elementId.replace('{{key}}', index)}
            width={colWidth || '33.33%'}
            large={`width: ${colWidth || '16.66%'};`}
            medium={`width: ${colWidth || '25%'};`}
          >
            <StyledLinkBox>
              <Link
                to={link}
                onClick={() => handleClick(text)}
                skip={skip || false}
              >
                <Text size="small" textAlign="center" color="dark-2" weight={500}>
                  {text}
                </Text>
              </Link>
            </StyledLinkBox>
          </MediaBox>
        )
      })}

      {displayMoreBtn && (
        <Box
          direction="row"
          justify="left"
          align="left"
          style={{ width: '100%', paddingTop: '20px', paddingBottom: '20px' }}
        >
          <ShowMoreButton
            custom
            hideBorder={false}
            color="white"
            weight={700}
            alignSelf="center"
            onClick={() => {
              setShowmoreFlag(!showmoreFlag)
            }}
            reverse="true"
            gap="xxsmall"
            label={showmoreFlag ? 'Show More' : 'Show Less'}
            icon={(
              <IcoMoon
                icon={showmoreFlag ? KeyboardArrowDownIcon : KeyboardArrowUpIcon}
                size="20px"
                style={{ fill: 'inherit' }}
              />
            )}
          />
        </Box>
      )}
    </Box>
  )
}
